// extracted by css-extract-rspack-plugin
export default {"variation":"i00NXKrAgAJLuAkT","color":"XPS0zsCQwNQuXSfK","display":"lwotywoV67Qm8sgz","allVariationsIcon":"h4mT6YhqMpEg8vr7"};